import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import * as Sentry from "@sentry/browser";
import ReactDOM from "react-dom";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "./SwiperConstruct";

type ConfigDataType = {c: string};
type PaLocalStorageType = {configData: ConfigDataType};
type PatutilType = {paLocalStorage: PaLocalStorageType};
declare global {
  interface Window {
    patutil: PatutilType | undefined;
  }
}

export const paCustomerId = () => {
  try {
    // When customer rejects the cookies, there will be no `window.patutil`
    // All else cases would be an error on PA side
    return window.patutil?.paLocalStorage.configData.c;
  } catch (e) {
    (e as Error).name = "PARecommendations" + (e as Error).name;
    Sentry.captureException(e, {
      tags: {
        occurrence: "RecommendationsPortal.paCustomerId"
      }
    });

    return undefined;
  }
};

// Empfehlungen für Sie
const RecommendationsPortalComponent: React.FC = () => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    let paUrl = paMainUrl;
    const customerId = paCustomerId();
    if (customerId) {
      paUrl += `Personalized?customerId=${customerId}`;
    } else {
      paUrl += "PopularItems";
    }
    void retrieveItemContent(paUrl, customer).then(setItems);
  }, []);

  if (!items.length) {
    return null;
  }

  return <SwiperConstruct items={items} title={t("product.recommendationsForYou")} />;
};

const RecommendationsPortal: React.FC = () => {
  const parentCategoriesElement = document.getElementById("PARecommendations");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="RecommendationsPortal">
      <Suspense fallback={null}>
        <RecommendationsPortalComponent />
      </Suspense>
    </ErrorBoundary>,
    parentCategoriesElement,
  );
};

export default RecommendationsPortal;
